import { useMemo } from "react"
import { MeshPhongMaterial } from "three"

import { buildings, colors } from "../../helpers/constants"
import { useColor } from "../../hooks/useColor"
import { StateWrapper } from "./StateWrapper"

const props = {
  flatShading: true,
  toneMapped: false,
  specular: "#fff",
  emissive: "#000",
  shininess: 5,
}

export const Historical = ({ nodes }) => {
  const { color } = useColor("historical", colors.historical)

  const { position, geometries } = buildings.historical

  const material = useMemo(
    () =>
      new MeshPhongMaterial({
        color,
        ...props,
      }),
    [color]
  )

  return (
    <StateWrapper name="historical" castShadow>
      <group position={position}>
        {geometries.map((geometry, i) => (
          <mesh
            name="historical"
            key={i}
            geometry={nodes[geometry].geometry}
            material={material}
          />
        ))}
      </group>
      <mesh
        geometry={nodes.Door.geometry}
        position={[15.11, 0.71, 30.5]}
        rotation={[Math.PI / 2, 0, -0.16]}
        material={material}
      />
    </StateWrapper>
  )
}
